export default __webpack_public_path__ + "static/media/arrowDown.dee68aa5.svg";